import { NavigationSection } from "./navigationConfig";

export const filterNavigationItems = (
  sections: NavigationSection[],
  canRoute: (href: string) => boolean
): NavigationSection[] => {
  return sections.map((section) => {
    const filteredItems = section.items.filter((item) => !item.isHiddenInNavigation && (!item.path || canRoute(item.path)));
    return { ...section, items: filteredItems }
  }).filter((section) => section.items.length > 0);
};